import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen.ts';
import type { AuthRole, PermissionRequest } from '@pac/auth-roles';
import { queryClient } from '@/queryClient.ts';

export type StaticRouteAuthorizationOption = {
  role?: 'anonymous' | AuthRole;
  permission?: PermissionRequest;
};

export const router = createRouter({ routeTree, context: { queryClient } });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface StaticDataRouteOption {
    authorization?: StaticRouteAuthorizationOption;
  }
}
